import React, { useMemo } from "react";
import { Link } from "gatsby";
import { BsCaretDownFill, BsCheckCircleFill, BsList, BsPersonFillCheck, BsTruck, BsX } from "react-icons/bs";
import HeaderAccount from "../../../../components/layouts/Layout/Header/Account";
import HeaderCart from "../../../../components/layouts/Layout/Header/Cart";
import { GatsbyImage, ImageDataLike, getImage } from "gatsby-plugin-image";
import Button from "../../../shared/Button";
import { HeaderProps } from "../../Default/Header";
import { Menu, MenuItem } from "../../../layouts/Layout/Footer";

export default function Header({
    salesChannel,
    logoFile,
    isSticky,
    isDrawerVisible,
    setIsDrawerVisible,
    isMobile,
    windowSize,
    menus,
    allMenus
}: HeaderProps) {

    const [secondMenu, setSecondMenu] = React.useState<MenuItem & { loadedMenus: Menu[] } | null>(null);

    const firstMenu = useMemo(() => {
        const menu = menus?.[0];
        if (menu) {
            return {
                ...menu,
                items: menu.items.sort((a, b) => a.sort > b.sort ? 1 : -1)
            };
        }
        return null;
    }, [menus]);

    const toggleSecondMenu = (menuItem: MenuItem) => (e: any) => {

        if (menuItem.childMenus && menuItem.childMenus.length > 0) {

            e.preventDefault();
            e.stopPropagation();

            if (secondMenu?.id === menuItem.id) {
                setSecondMenu(null);
                return;
            }

            setSecondMenu({
                ...menuItem,
                loadedMenus: menuItem.childMenus.map(m => allMenus.find(mm => mm.id === m.id) as Menu)
            });

            return;
        } else {
            setIsDrawerVisible(false);
        }

    }

    const handleClassroomClick = () => {
        if (typeof window !== "undefined") {
            window.open("https://app2.sailingcourseonline.co.uk");
        }
    }

    return (
        <>
            <header
                className={`h-[80px] sticky top-0 left-0 w-full bg-white border-b-2`}
                style={{ zIndex: 1100 }}
            >
                <div className="mx-auto px-5">
                    <div className="
                        flex justify-between items-center -mx-2
                        xl:justify-start
                    ">
                        <div className="px-2 xl:hidden">
                            <button
                                title={isDrawerVisible ? "Close Menu" : "Open Menu"}
                                onClick={() => setIsDrawerVisible(!isDrawerVisible)}
                                className="flex items-center px-3"
                            >
                                <BsList className="w-[25px] h-[25px]" />
                            </button>
                        </div>
                        <div className="px-2 flex">
                            <Link title="Home" to="/">
                                <div className="
                                    max-w-[200px] max-h-[60px] 
                                    xl:max-w-[100px]
                                    2xl:max-w-[200px]">
                                    <HeaderLogo
                                        logoFile={logoFile}
                                        alt={salesChannel.name + " Logo"}
                                    />
                                </div>
                            </Link>
                        </div>
                        <div
                            className={`
                                sco-header ${isDrawerVisible && "sco-header--visible"}
                                flex justify-end fixed left-0 w-full h-full bg-black bg-opacity-50 z-30
                                xl:static xl:h-auto xl:bg-transparent xl:px-3 xl:flex-1 xl:justify-center
                            `}
                            onClick={() => setIsDrawerVisible(false)}
                        >
                            <ul
                                className={`
                                sco-header-menu ${isDrawerVisible && "sco-header-menu--visible"}
                                relative flex flex-col h-full bg-white py-[30px]
                                xl:h-auto xl:bg-transparent xl:p-0 xl:flex-row xl:w-auto
                            `}
                                onClick={e => e.stopPropagation()}
                            >
                                <li>
                                    <span
                                        className="
                                        flex justify-between px-8 pb-5
                                        xl:hidden
                                    "
                                    >
                                        <span className="bg-primary font-bold uppercase text-sm px-2 py-1 rounded">
                                            Menu
                                        </span>

                                        <button
                                            title="Close Menu"
                                            onClick={() => setIsDrawerVisible(false)}
                                            className="flex items-center">
                                            <BsX className="w-[25px] h-[25px]" />
                                        </button>
                                    </span>
                                </li>

                                {firstMenu?.items?.map(menuItem => (
                                    <li key={menuItem.id} className="">
                                        <Link
                                            to={`${menuItem.link?.src}`}
                                            onClick={toggleSecondMenu(menuItem)}
                                            className={`
                                                ${secondMenu?.id === menuItem.id ? "bg-secondary text-white" : ""}  
                                                flex items-center px-8 py-[13px] text-xl font-semibold
                                                xl:h-[80px] xl:px-3 xl:py-2 xl:text-sm xl:font-semibold xl:tracking-wider
                                                2xl:py-2 2xl:px-5 2xl:text-base
                                            `}
                                        >
                                            {menuItem.name}
                                            {menuItem.childMenus && menuItem.childMenus.length > 0 && (
                                                <BsCaretDownFill className="ml-2" />
                                            )}
                                        </Link>


                                        {secondMenu?.id == menuItem.id && (
                                            <div className="
                                                    w-full px-5 z-50 bg-secondary text-white
                                                    xl:fixed xl:top-[80px] xl:left-0  xl:py-5"
                                            >
                                                <div className="max-w-screen-xl px-3 mx-auto py-5">
                                                    <div className="flex flex-wrap -mx-10">
                                                        {secondMenu.loadedMenus.map(menu => (
                                                            <div
                                                                key={menu.id}
                                                                className="
                                        px-10 w-full
                                        xl:w-1/3
                                    ">
                                                                <h3 className="
                                                                    text-xl
                                                                    xl:text-4xl">
                                                                    {menu.displayName}
                                                                </h3>
                                                                {menu.items.map(item => (
                                                                    <Link key={menu.id + item.id} to={item.link?.src || ""} className="
                                                                    block py-2 my-3  underline
                                                                    xl:text-2xl    
                                                                ">
                                                                        {item.name}
                                                                    </Link>
                                                                ))}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    </li>
                                ))}

                                <li className="xl:hidden px-8 py-[13px]">
                                    <Button onClick={handleClassroomClick} textSize="text-base">
                                        Classroom
                                    </Button>
                                </li>

                            </ul>
                        </div>

                        <div className="hidden px-2">
                            <HeaderAccount isMobile={isMobile} />
                        </div>

                        <div className="px-2 hidden xl:flex flex-col items-end">
                            <a className="block underline font-bold mb-2" href={`tel:${salesChannel.phone}`}>
                                {salesChannel.phone}
                            </a>
                            <div>
                                <Button onClick={handleClassroomClick} textSize="text-base" padding="px-3 py-2">
                                    Classroom
                                </Button>
                            </div>
                        </div>

                        <div className="px-2">
                            <HeaderCart />
                        </div>

                    </div>
                </div>
            </header>
            <section className="py-5 bg-secondary text-white">
                <div className="px-4 mx-auto max-w-screen-xl">
                    <div className="flex justify-center xl:justify-between xl:-mx-6">
                        <div className="px-6 items-center hidden xl:flex">
                            <BsTruck size={30} className="text-primary mr-3" />
                            <div>
                                <span className="uppercase font-bold">
                                    Free Worldwide Delivery
                                </span>
                                <small className="block">
                                    Getting you started as soon as possible
                                </small>
                            </div>
                        </div>
                        <div className="px-6 items-center hidden xl:flex">
                            <BsPersonFillCheck size={30} className="text-primary mr-3" />
                            <div>
                                <span className="uppercase font-bold">
                                    RYA Yachtmaster™ Instructors
                                </span>
                                <small className="block">
                                    From novice to expert, we have your back
                                </small>
                            </div>
                        </div>
                        <div className="px-6 items-center hidden xl:flex">
                            <BsCheckCircleFill size={30} className="text-primary mr-3" />
                            <div>
                                <span className="uppercase font-bold">
                                    Pass with confidence
                                </span>
                                <small className="block">
                                    Join thousands of happy students
                                </small>
                            </div>
                        </div>
                        <div className="px-6 flex items-center">
                            <img alt="Feefo logo" width="190" src="https://api.feefo.com/api/logo?merchantidentifier=sailing-course-online&amp;template=Service-Stars-Yellow-Square-316x80.png" title="See what our customers say about us" />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

const HeaderLogo = ({ logoFile, alt }: { logoFile?: { node: ImageDataLike }, alt: string }) => {

    if (logoFile) {
        const gatsbyImage = getImage(logoFile);
        if (gatsbyImage) {
            return <GatsbyImage
                image={gatsbyImage}
                alt={alt}
            />;
        }
    }

    return <></>

}